import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "22",
      height: "20",
      x: "4",
      y: "5",
      "stroke-dasharray": "3.2 2.6",
      rx: "2"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "m8 19.5 3.5-7h5l3.5 4h3" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }